// NGRX
import {Action} from '@ngrx/store';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
// Models
import {LeaderLevelModel} from '../_models/leader-level.model';
import {Update} from '@ngrx/entity';

export enum LeaderLevelActionTypes {
    LeaderLevelOnServerCreated = '[Edit LeaderLevel Component] LeaderLevel On Server Created',
    LeaderLevelCreated = '[Edit LeaderLevel Component] LeaderLevel Created',
    LeaderLevelUpdated = '[Edit LeaderLevel Component] LeaderLevel Updated',
    OneLeaderLevelDeleted = '[LeaderLevels List Page] One LeaderLevel Deleted',
    LeaderLevelsPageRequested = '[LeaderLevels List Page] LeaderLevels Page Requested',
    LeaderLevelsPageLoaded = '[LeaderLevels API] LeaderLevels Page Loaded',
    LeaderLevelsPageCancelled = '[LeaderLevels API] LeaderLevels Page Cancelled',
    LeaderLevelsPageToggleLoading = '[LeaderLevels] LeaderLevels Page Toggle Loading',
    LeaderLevelsActionToggleLoading = '[LeaderLevels] LeaderLevels Action Toggle Loading'
}

export class LeaderLevelOnServerCreated implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelOnServerCreated;

    constructor(public payload: { leaderLevel: LeaderLevelModel }) {
    }
}

export class LeaderLevelCreated implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelCreated;

    constructor(public payload: { leaderLevel: LeaderLevelModel }) {
    }
}

export class LeaderLevelUpdated implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelUpdated;

    constructor(public payload: {
        partialLeaderLevel: Update<LeaderLevelModel>, // For State update
        leaderLevel: LeaderLevelModel // For Server update (through service)
    }) {
    }
}

export class OneLeaderLevelDeleted implements Action {
    readonly type = LeaderLevelActionTypes.OneLeaderLevelDeleted;

    constructor(public payload: { id: number }) {
    }
}

export class LeaderLevelsPageRequested implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelsPageRequested;

    constructor(public payload: { page: QueryParamsModel }) {
    }
}

export class LeaderLevelsPageLoaded implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelsPageLoaded;

    constructor(public payload: { leaderLevels: LeaderLevelModel[], totalCount: number, page: QueryParamsModel }) {
    }
}

export class LeaderLevelsPageCancelled implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelsPageCancelled;
}

export class LeaderLevelsPageToggleLoading implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelsPageToggleLoading;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class LeaderLevelsActionToggleLoading implements Action {
    readonly type = LeaderLevelActionTypes.LeaderLevelsActionToggleLoading;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export type LeaderLevelActions = LeaderLevelOnServerCreated
    | LeaderLevelCreated
    | LeaderLevelUpdated
    | OneLeaderLevelDeleted
    | LeaderLevelsPageRequested
    | LeaderLevelsPageLoaded
    | LeaderLevelsPageCancelled
    | LeaderLevelsPageToggleLoading
    | LeaderLevelsActionToggleLoading;
